import Controller from "./contractorInvoiceItem.controller";
import template from "./contractorInvoiceItem.html";

const contractorInvoiceItem = {
  template,
  controller: Controller,
};

export default contractorInvoiceItem;



// WEBPACK FOOTER //
// ./src/pages/contractorInvoiceItem/contractorInvoiceItem.component.js